<style lang="scss" scoped>
	@import "./supplylist.css";
	.btn_cla{
		border-radius: 30px;
		padding: 0.3rem 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #ffffff;
		cursor: pointer;
		transition: opacity 0.2s;
		outline: none;
		position: relative;
	}
	.btn_cla::before {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100%;
		height: 100%;
		background-color: #000;
		border: inherit;
		border-color: #000;
		border-radius: inherit;
		transform: translate(-50%, -50%);
		opacity: 0;
		content: ' ';
	}
	.btn_cla:active::before {
		opacity: 0.1;
	}
</style>
<style>
	.grayc{
		color: #cfcfcf !important;
	}
	.greenc{
		/* color: #0c8b97 !important; */
		color: #808080 !important;
	}
	.lable_cla .ant-form-item-label{
		width: 87px;
	}
@media screen and (min-width:2200px){
	.lable_cla .ant-form-item-label{
		width:110px !important;
	}

}
</style>
<template>
	<div id="supplylist">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row type='flex' justify='space-between'>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="登錄平台" class="formItem lable_cla">
							<a-select v-model="params.loginPlatform" placeholder="請選擇" @change='searchEvent'>
								<a-select-option v-for="(item) in platformArr" :key="item.value"
									:value="item.value" style='width:100%'>{{item.label}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label=" 股票代碼" class="formItem lable_cla">
							<a-input v-model="params.stockCode" placeholder="請輸入股票代碼" @input='handnum' :allowClear="true" @change="handleClear()"/>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="股票市場" class="formItem lable_cla">
							<a-select v-model="params.stockMarket" placeholder="請選擇" @change='searchEvent'>
								<a-select-option value="" style='width:100%'>全部</a-select-option>
								<a-select-option value="香港市場" style='width:100%'>香港市場</a-select-option>
								<a-select-option value="美國市場" style='width:100%'>美國市場</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="搜索日期" class="formItem lable_cla">
							<!-- <a-select v-model="params.dailyClick" placeholder="請選擇" @change='searchEvent'>
								<a-select-option v-for="(item) in admintype" :key="item.key"
									:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
							</a-select> -->
							<a-range-picker :placeholder="['開始日期','結束日期']" v-model="params.timeDate" @change="fanhand()" :disabled-date="disabledDate"/>
						</a-form-model-item>

					</a-col>
				</a-row>
				<a-row style="margin-top: 1rem;" type='flex' justify='space-between'>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="日/點擊量" class="formItem lable_cla">
							<a-select v-model="params.dailyClick" placeholder="請選擇" @change='searchEvent'>
								<a-select-option v-for="(item) in admintype1" :key="item.key"
									:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<!-- <a-form-model-item label="交易股數" class="formItem lable_cla">
							<a-select v-model="params.stockClick" placeholder="請選擇" @change='searchEvent'>
								<a-select-option v-for="(item) in admintype" :key="item.key"
									:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
							</a-select>
						</a-form-model-item> -->
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="月/點擊量" class="formItem lable_cla">
							<a-select v-model="params.monthlyClick" placeholder="請選擇" @change='searchEvent'>
								<a-select-option v-for="(item) in admintype1" :key="item.key"
									:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }">
						<a-form-model-item label="年/點擊量" class="formItem lable_cla">
							<a-select v-model="params.yearlyClick" placeholder="請選擇" @change='searchEvent'>
								<a-select-option v-for="(item) in admintype1" :key="item.key"
									:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :xl="{ span: 5 }"
						style="display: inline-flex;align-items: center;justify-content: flex-start;">
						<div style="display: flex;">
							<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
								<img src="../../image/icon_sousuo.png" class="btnIcon" />
								<span>搜索</span>
							</div>
							<div class="btn_cla" style="background-color:#ffa647;"
								@click="clearEvent">
								<img src="../../image/icon_chongzhi.png" class="btnIcon" />
								<span>重置</span>
							</div>
							<!-- <a-button class="topBtn" style="background-color:#3bc7a1;margin-right: 2rem;" @click="searchEvent">
								<img src="../../image/icon_sousuo.png" class="btnIcon" />
								<span>搜索</span>
							</a-button>
							<a-button class="topBtn" style="background-color:#ffa647;margin-left:auto;"
								@click="clearEvent">
								<img src="../../image/icon_chongzhi.png" class="btnIcon" />
								<span>重置</span>
							</a-button> -->
						</div>
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
<!-- 
				<div  @click='visible_bold = 1' class='btn_list' v-if='acontractinsert'>
					<img src="../../image/emp1.png" class="btnIcon" />
					<span style="color: #ffa647;">添加</span>
				</div> -->
				<!-- @click='pdfEvent'  -->
				<div class='btn_list' @click="upClick()">
					<a-icon type="file-pdf" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem'/>
					<span style="color:#3bc7a1;">導出</span>
				</div>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index' :customRow='rowstely'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">

				<div slot='loginPlatform' style='text-align: center;' slot-scope='record'>{{record.loginPlatform}}</div>
				<div slot='service_type' style='text-align: center;' slot-scope='record'>{{record.service_type}}</div>
				<div slot='stockCode' slot-scope='record' style="text-align: center;">
					{{record.stockCode}}
				</div>
				<div slot='stockName' slot-scope='record' >
					<!-- style="margin-left: 2rem ;text-align: left;" -->
					{{record.stockName}}
				</div>
				<div slot='status' slot-scope="record" style="white-space: nowrap;">
					<div v-if='record.status == "已過期"||record.status == "已完結"'>{{record.status}}</div>
					<div v-else-if='record.status == "正常"' style='color: #3bc7a1;' >{{record.status}}</div>
					<div v-else  style='color: #ee5253;'>{{record.status}}</div>
				</div>
				<span slot='regdate' @click='uploadfn("ASC",1)' style="cursor: pointer;">
					日/點擊量
					<div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.dailySort!=="ASC"?"grayc":"greenc"' 
						style='position: absolute;top: 0;'/>
						<a-icon type="caret-down" :class='params.dailySort!=="DESC"?"grayc":"greenc"'
						 style='position: absolute;top: .6rem;'/>
					</div>
				</span>
				<span slot='expire_date'  @click='uploadfn("ASC",2)' style="cursor: pointer;">
					月/點擊量 
					<div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.monthlySort!=="ASC"?"grayc":"greenc"'
						style='position: absolute;top: 0;'/>
						<a-icon type="caret-down" :class='params.monthlySort!=="DESC"?"grayc":"greenc"'
						 style='position: absolute;top: .6rem;'/>
					</div>
				</span>
				<span slot='year_click' @click='uploadfn("ASC",3)'  style="cursor: pointer;">
					年/點擊量
					<div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.yearlySort!=="ASC"?"grayc":"greenc"'
						style='position: absolute;top: 0;'/>
						<a-icon type="caret-down" :class='params.yearlySort!=="DESC"?"grayc":"greenc"'
						 style='position: absolute;top: .6rem;'/>
					</div>
				</span>
				<span slot='totalStockNumber' @click='uploadfn("ASC",4)'   style="cursor: pointer;">
					交易股數 
					<div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.stockSort!=="ASC"?"grayc":"greenc"'
						style='position: absolute;top: 0;'/>
						<a-icon type="caret-down" :class='params.stockSort!=="DESC"?"grayc":"greenc"'
						 style='position: absolute;top: .6rem;'/>
					</div>
				</span>
				
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div>
							<img :src="record.visible_bold !== 1?require('../../image/lea/chart.png'):require('../../image/lea/chart.png')" 
							class="imageb" @click='handediot(record,2)' 
							 >
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<!-- <handItem v-if='visible_bold==1' @child='handclose' :items='isdate'></handItem> -->
		<handItems v-if='visible_bold==2' @child='handclose' :items='echartsVal'></handItems>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<div :class="['pdfview',pdfShow?'pdfShow':'']" @click='pdfShowUNEvent()'>
			<div class='pdfviewIn'>
				<div class='pdfTitle'>
					<img src="../../image/icon_dayin.png" alt=""  @click.stop="printEvent()">
					<img @click.stop="downLoad()" src="../../image/icon_xiazai1.png">
				</div>
				<iframe id='iframePdf1' :src='allurl' style='width:100%;height:100%;' frameborder='0'></iframe>
				<iframe id='toPrintIframe' style='display:none' :src='pdfBolUrl' frameborder='0'></iframe>
			</div>
		</div>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
</template>
<script>
	import exportData from "./components/exportData";
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import ediotitem from './components/ediotitem.vue'
	import handItems from './components/handItemform'
	import { saveFileToLink,saveFileToBlob  } from 'web-downloadfile';
	import task from './components/task.vue'
	import moment from 'moment'  //引入moment插件
	export default {
		components: {task,ediotitem,handItems,exportData},
		data() {
			return {
				upFlag:false,
				ishandout:false,
				echartsVal:'',
				pdfShow:false,
				pdfBolUrl:'',
				pdfUrl : '',
				blob:'',
				allurl:'',
				isdate:'',
				visible_bold:'',
				icon_pdf,
				icon_pdf1,
				//系統服務新增管理  acontractinsert
				//系統服務編輯管理  acontractedit
				acontractinsert: this.$store.state.rolesdata.indexOf('acontractinsert') >= 0,
				acontractedit: this.$store.state.rolesdata.indexOf('acontractedit') >= 0,
				admintypeArr: [
					{
						text: '全部',
						value: ''
					},{
						text: '正常',
						value: '1'
					},
					{
						text: '已完結',
						value: '2'
					},{
						text: '即將完結',
						value: '3'
					},
				],
				admintype: [
					{
						text: '全部',
						value: ''
					},
					{
						text: '0-500',
						value: '0-500'
					},
					{
						text: '500-1000',
						value: '500-1000'
					},
					{
						text: '>1000',
						value: '>1000'
					},
				],
				admintype1: [
					{
						text: '全部',
						value: ''
					},
					{
						text: '0-5000',
						value: '0-5000'
					},
					{
						text: '5000-10000',
						value: '5000-10000'
					},
					{
						text: '>10000',
						value: '>10000'
					},
				],
				platformArr: [
					{
					value: "",
					label: "全部",
					},
					{
					value: "iPhone",
					label: "iPhone",
					},
					{
					value: "Android",
					label: "Android",
					},
					{
					value: "iPad",
					label: "iPad",
					},
				],
				tzPageNum: '',
				columns: [
					{
						title: '登錄平台', 
						dataIndex: '',
						align: 'center',
						width: '12%',
						scopedSlots:{
							customRender:'loginPlatform'
						}
					},
					{
						title: '股票代碼',
						dataIndex: '',
						align: 'center',
						width: '12%',
						scopedSlots:{
							customRender:'stockCode'
						},
					},
					{
						title: '股票名稱',
						dataIndex: '',
						align: 'center',
						width: '20%',
						scopedSlots:{
							customRender:'stockName'
						},
					},
					{
						title: '股票市場',
						dataIndex: 'stockMarket',
						width: '12%',
						align: 'center',
					},
					{
						// title: '開始日期',
						dataIndex: 'dailyCount',
						align: 'center',
						slots:{
							title:'regdate'
						}
					},
					{
						// title: '完結日期',
						dataIndex: 'monthlyCount',
						align: 'center',
						slots:{
							title:'expire_date'
						}
					},
					
					{
						// title: '年/點擊量',
						dataIndex: 'yearlyCount',
						align: 'center',
						slots:{
							title:'year_click'
						}
					},
					// {
					// 	// title: '交易股數',
					// 	dataIndex: 'totalStockNumber',
					// 	align: 'center',
					// 	slots: {
					// 		title:'totalStockNumber'
					// 	}
					// },
					{
						title: '詳情',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [ ],
				selectedRows: [], //checkbox
				params: { // 任務數
					loginPlatform:'',
					stockMarket:'',
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					perPage: 10,	 //每頁條目數
					stockCode:'',
					// missionflag : 0,//任務中  1
					dailySort:'',
					monthlySort:'',
					yearlySort:'',
					stockSort:'',
					dailyClick:'',
					monthlyClick:'',
					yearlyClick:'',
					stockClick:'',
					timeDate:[],
					expire_date_begin:'',
					expire_date_end:'',
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
		},
		methods: {
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.pdfEvent(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			// 表格导出下载
			queryData(pxfs){
				let url = ''
				let sort =  pxfs == undefined ? '' : pxfs
				url = this.$api.exportStockClickExcel;
				url += '?token=' + this.$store.state.token
				url += '&loginPlatform='+this.params.loginPlatform
				url += '&stockCode='+this.params.stockCode
				url += '&stockMarket=' + this.params.stockMarket
				// url += '&stockClick=' + this.params.stockClick
				url += '&dailyClick=' + this.params.dailyClick
				url += '&monthlyClick=' + this.params.monthlyClick
				url += '&yearlyClick=' + this.params.yearlyClick
				url += '&expire_date_begin=' + this.params.expire_date_begin
				url += '&expire_date_end=' + this.params.expire_date_end
				url += '&sort=' + sort
				url += '&dailySort=' + this.params.dailySort
				url += '&monthlySort=' + this.params.monthlySort
				url += '&yearlySort=' + this.params.yearlySort
				url += '&stockSort=' + this.params.stockSort
				console.log(url);
				window.location.href = url;
			},
			upClick(){
				this.upFlag = true
			},
			handleClear(val){
                if (!this.params.stockCode) {
                    this.messLoad()
                }
            },
			handleCancel(ev){
                this.ishandout = false
			},
			disabledDate(current){
				return current && current > moment().endOf('day')
			},
			downLoad(){
				console.log("點擊");
                let _this = this;
                // saveFileToLink(_this.blob,'股票點擊','pdf');
				const date = new Date();
				const year = date.getFullYear();
				let month = date.getMonth() + 1;
				if (month < 10) {
					month = `0${month}`;
				}
				let day = date.getDate();
				if (day < 10) {
					day = `0${day}`;
				}
				var currentDate = `${year}${month}${day}`;

				saveFileToBlob(_this.blob,currentDate + ' 股票點擊','pdf');
            },

			fanhand(val) {
				this.params.expire_date_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.expire_date_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			handnum(){
				if(isNaN(this.params.stockName)){
					this.params.stockName = ''
				}
			},

			pdfEvent(pxfs){
				let str = this.$api.pdfs;
				let url = this.$api.exportStockClickPDF;
				let sort =  pxfs == undefined ? '' : pxfs
				url += '?token=' + this.$store.state.token
				url += '&loginPlatform='+this.params.loginPlatform
				url += '&stockCode='+this.params.stockCode
				url += '&stockMarket=' + this.params.stockMarket
				// url += '&stockClick=' + this.params.stockClick
				url += '&dailyClick=' + this.params.dailyClick
				url += '&monthlyClick=' + this.params.monthlyClick
				url += '&yearlyClick=' + this.params.yearlyClick

				url += '&expire_date_begin=' + this.params.expire_date_begin
				url += '&expire_date_end=' + this.params.expire_date_end
				url += '&sort=' + sort
				url += '&dailySort=' + this.params.dailySort
				url += '&monthlySort=' + this.params.monthlySort
				url += '&yearlySort=' + this.params.yearlySort
				url += '&stockSort=' + this.params.stockSort
				this.allurl = str + url;
				let _this = this; 
				_this.pdfUrl = url;
				https.fetchGetPdf(_this.pdfUrl).then((data)=>{
					let blob = new Blob([data],{
						type:'application/pdf'
					})
					_this.blob = blob;
					let b=window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err=>{
					console.log(err)
				})
				setTimeout(()=>{
					this.pdfShow = true
				},500)
			},

			printEvent(){
			    let _this = this;
			    const printIframe = document.getElementById("toPrintIframe");
			    let frameWindow = printIframe.contentWindow;
			    frameWindow.print();
			    setTimeout(()=>{
			        window.URL.revokeObjectURL(_this.blob);
			    },500)
			},
			pdfShowUNEvent(){
				this.pdfShow = false
				// 关闭导出弹窗后重新加载列表接口
				// this.messLoad()
			},
			rowstely(record, index) {
				if (record.status == "已過期"||record.status == "已完結") {//
					return {
						style: {
							'color': '#999',opacity: '.5'
						},
					}
				}
			},
			uploadfn(val,a){
				if (a == 1) {
					this.params.monthlySort = ''
					this.params.yearlySort = ''
					this.params.stockSort = ''
					if(this.params.dailySort == 'ASC'){
						this.params.dailySort = 'DESC'
					}else if(this.params.dailySort == 'DESC'){
						this.params.dailySort = ''
					}else if(this.params.dailySort == ''){
						this.params.dailySort = 'ASC'
					}
				}else if (a == 2) {
					this.params.dailySort = ''
					this.params.yearlySort = ''
					this.params.stockSort = ''
					if(this.params.monthlySort == 'ASC'){
						this.params.monthlySort = 'DESC'
					}else if(this.params.monthlySort == 'DESC'){
						this.params.monthlySort = ''
					}else if(this.params.monthlySort == ''){
						this.params.monthlySort = 'ASC'
					}
					
				}else if (a == 3) {
					this.params.monthlySort = ''
					this.params.dailySort = ''
					this.params.stockSort = ''
					if(this.params.yearlySort == 'ASC'){
						this.params.yearlySort = 'DESC'
					}else if(this.params.yearlySort == 'DESC'){
						this.params.yearlySort = ''
					}else if(this.params.yearlySort == ''){
						this.params.yearlySort = 'ASC'
					}
					
				}else if (a == 4) {
					this.params.monthlySort = ''
					this.params.yearlySort = ''
					this.params.dailySort = ''
					if(this.params.stockSort == 'ASC'){
						this.params.stockSort = 'DESC'
					}else if(this.params.stockSort == 'DESC'){
						this.params.stockSort = ''
					}else if(this.params.stockSort == ''){
						this.params.stockSort = 'ASC'
					}
					
				}
				// if(a){
				// 	if(this.params.dailySort == 'up'){
				// 		this.params.dailySort = 'down'
				// 	}else if(this.params.dailySort == 'down'){
				// 		this.params.dailySort = ''
				// 	}else if(this.params.dailySort == ''){
				// 		this.params.dailySort = 'up'
				// 	}
				// }else{
				// 	if(this.params.expire_date_sort == 'up'){
				// 		this.params.expire_date_sort = 'down'
				// 	}else if(this.params.expire_date_sort == 'down'){
				// 		this.params.expire_date_sort = ''
				// 	}else if(this.params.expire_date_sort == ''){
				// 		this.params.expire_date_sort = 'up'
				// 	}
				// }
				// console.log(this.params)
				this.messLoad();
			},
			deletefn(ev){
				this.$ajax({
					method: 'post',
					url: this.$api.deletOther,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"token":this.$store.state.token,
						 "systemserviceid":ev.systemserviceid,
						 "flag":"systemservice"
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.messLoad();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handediot(val,a){
				console.log(val);
				this.visible_bold = a
				this.echartsVal = val
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			fandfn(val){
				if(val == 'back'){
					this.params.missionflag = 0
					this.params.status = ''
				}else{
					this.params.missionflag = 1
					this.params.status = val == '即將到期'?'3':''
				}
				this.messLoad()
			},
			handopen(){
				window.location.href = this.$api.getExcel+'?token=' +this.$store.state.token
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handclose(val) {
				this.isdate = ''
				this.visible_bold = '';
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['visible_bold'] = ''
						ev['visible_bold1'] = ''
					}
				})
				if (val) {
					this.messLoad();
				}
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getStockClick,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {

						this.columnsData = res.data.stockClickList
						if (this.params.loginPlatform || this.params.stockCode || this.params.stockMarket || 
							this.params.expire_date_begin || this.params.dailyClick || this.params.monthlyClick ||
							this.params.yearlyClick) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					App.oTool.warningT(err.data.qmismsg);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			clearEvent() {
				this.params = {}
				this.params = {
					loginPlatform:'',
					stockMarket:'',
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					perPage: 10,	 //每頁條目數
					stockCode:'',
					// missionflag : 0,//任務中  1
					dailySort:'',
					monthlySort:'',
					yearlySort:'',
					stockSort:'',
					dailyClick:'',
					monthlyClick:'',
					yearlyClick:'',
					stockClick:'',
					timeDate:[],
					expire_date_begin:'',
					expire_date_end:'',
				}
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
<style lang='scss'>
	#supplylist {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>